import React, { useState, useEffect } from 'react';
import { LeaderboardPeriod, PERIOD_CONFIG } from 'types/interfaces/leaderboard';
import './LeaderboardFilters.css';

interface LeaderboardFiltersProps {
  activePeriod: LeaderboardPeriod;
  onPeriodChange: (period: LeaderboardPeriod) => void;
  country: string;
  onCountryChange: (country: string) => void;
  search: string;
  onSearchChange: (search: string) => void;
}

const PERIODS: LeaderboardPeriod[] = ['week', 'month', 'all_time'];

// Common countries for filtering
const COUNTRIES = [
  { code: '', label: 'All Countries' },
  { code: 'US', label: 'United States' },
  { code: 'CA', label: 'Canada' },
  { code: 'GB', label: 'United Kingdom' },
  { code: 'AU', label: 'Australia' },
  { code: 'DE', label: 'Germany' },
  { code: 'FR', label: 'France' },
  { code: 'JP', label: 'Japan' },
  { code: 'NL', label: 'Netherlands' },
  { code: 'ES', label: 'Spain' },
  { code: 'IT', label: 'Italy' },
  { code: 'BR', label: 'Brazil' },
  { code: 'MX', label: 'Mexico' },
];

const LeaderboardFilters: React.FC<LeaderboardFiltersProps> = ({
  activePeriod,
  onPeriodChange,
  country,
  onCountryChange,
  search,
  onSearchChange,
}) => {
  const [localSearch, setLocalSearch] = useState(search);

  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => {
      onSearchChange(localSearch);
    }, 300);
    return () => clearTimeout(timer);
  }, [localSearch, onSearchChange]);

  // Sync local search with parent state
  useEffect(() => {
    setLocalSearch(search);
  }, [search]);

  return (
    <div className="leaderboard-filters">
      <div className="leaderboard-filters__period">
        {PERIODS.map((period) => (
          <button
            key={period}
            className={`leaderboard-filters__period-btn ${activePeriod === period ? 'leaderboard-filters__period-btn--active' : ''}`}
            onClick={() => onPeriodChange(period)}
          >
            {PERIOD_CONFIG[period].label}
          </button>
        ))}
      </div>

      <div className="leaderboard-filters__controls">
        <select
          className="leaderboard-filters__country"
          value={country}
          onChange={(e) => onCountryChange(e.target.value)}
        >
          {COUNTRIES.map((c) => (
            <option key={c.code} value={c.code}>
              {c.label}
            </option>
          ))}
        </select>

        <div className="leaderboard-filters__search">
          <input
            type="text"
            placeholder="Search username..."
            value={localSearch}
            onChange={(e) => setLocalSearch(e.target.value)}
            className="leaderboard-filters__search-input"
          />
          {localSearch && (
            <button
              className="leaderboard-filters__search-clear"
              onClick={() => setLocalSearch('')}
              aria-label="Clear search"
            >
              &times;
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeaderboardFilters;
